// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadCategory from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategory";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductStateByPath } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { getPageLinkByPageType, useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { AlternatePackagingAttributesModel } from "@insite/client-framework/Types/ApiModels";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import DataTable from "@insite/mobius/DataTable";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { Clickable, DataTableBody, DataTableCell, DataTableRow, Link, Modal } from "@insite/mobius/index";
import { LinkPresentationProps, LinkProps } from "@insite/mobius/Link";
import { ModalProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import { getAlternatePackagingDataView } from "@store/Framework/Store/Greif/Data/AlternatePackaging/AlternatePackagingSelectors";
import loadProductAlternatePackaging from "@store/Framework/Store/Greif/Data/AlternatePackaging/Handlers/LoadAlternatePackaging";
import setProductAlternatePackaging from "@store/Framework/Store/Greif/Data/AlternatePackaging/Handlers/SetAlternatePackaging";
import AlternativeIcon, { AlternativeIconStyles } from "@store/Library/Components/AlternativeIcon";
import LinkBack, { LinkBackPresentationProps } from "@store/Library/Components/Toolkit/LinkBack";
import Loader from "@store/Library/Components/Toolkit/Loader";
import { buttonStyles, buttonThemeStyles } from "@store/Themes/common/mixins/button";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import parse from "html-react-parser";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const enum fields {
    disclairmerLabel = "disclairmerLabel",
    disclaimerAsLink = "disclaimerAsLink",
    disclaimerLink = "disclaimerLink",
    openLinkInNewTab = "openLinkInNewTab",
    disclaimerText = "disclaimerText",
    contactActionLabel = "contactActionLabel",
    typeDescriptions = "typeDescriptions",
    typeKey = "typeKey",
    description = "description",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.disclairmerLabel]: string;
        [fields.disclaimerAsLink]: boolean;
        [fields.disclaimerLink]: LinkFieldValue;
        [fields.openLinkInNewTab]: boolean;
        [fields.contactActionLabel]: string;
        [fields.typeDescriptions]: {
            fields: {
                [fields.typeKey]: string;
                [fields.description]: string;
            };
        }[];
        [fields.disclaimerText]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const queryString = location.search;
    const queryParams = parseQueryString<{ type: string; productPath: string }>(queryString.replace("?", ""));
    const { type, productPath } = queryParams;
    const product = getProductStateByPath(state, productPath);
    const productErpNumber = product?.value?.productNumber || "";
    const superAndSubCategories = productErpNumber?.substring(0, 4) || "";
    const productAttributeTypes = product?.value?.attributeTypes || [];

    return {
        type,
        productPath,
        productErpNumber,
        superAndSubCategories,
        productAttributeTypes,
        alternatePackagingDataView: getAlternatePackagingDataView(state, {
            productErpNumber,
            superAndSubCategories,
            attributeTypes: productAttributeTypes,
        }),
        formPageLink: getPageLinkByPageType(state, constants.pageType.recommendedProductRequest),
    };
};

const mapDispatchToProps = {
    loadCategory,
    setProductAlternatePackaging,
    loadProductAlternatePackaging,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasProductContext;

interface ProductAlternativePackagingTypeInformationStyles {
    centeringWrapper?: InjectableCss;
    wrapper?: InjectableCss;
    linkBack?: LinkBackPresentationProps;
    typeWrapper?: InjectableCss;
    tableWrapper?: InjectableCss;
    choiceTitle?: TypographyPresentationProps;
    tableHeader?: DataTableCellProps;
    cellTitle?: DataTableCellProps;
    cellValue?: DataTableCellProps;
    cellAlternateValue?: DataTableCellProps;
    modal?: ModalProps;
    alternativeIcon?: AlternativeIconStyles;
    disclaimerAction?: LinkPresentationProps | ClickablePresentationProps;
    actionWrapper?: InjectableCss;
    contactActionLink?: LinkProps;
    legalText?: TypographyPresentationProps;
}

const productAlternativePackagingTypeInformationStyles: ProductAlternativePackagingTypeInformationStyles = {
    centeringWrapper: {
        css: css`
            display: flex;
            height: ${pxToRem(300)};
            justify-content: center;
            align-items: center;
        `,
    },
    wrapper: {
        css: css`
            ${spacingStyles(null, pxToRem(32))}
        `,
    },
    typeWrapper: {
        css: css`
            ${spacingStyles(null, pxToRem(32))}
        `,
    },
    tableWrapper: {
        css: css`
            position: relative;
            width: 100%;
            overflow-x: auto;
        `,
    },
    choiceTitle: {
        forwardAs: "h1",
        variant: "h3",
        css: css`
            margin-bottom: ${pxToRem(20)};
        `,
    },
    tableHeader: {
        css: css`
            max-width: ${pxToRem(200)};
            color: ${getColor("text.accent")};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            word-wrap: break-word;
            white-space: break-spaces;
        `,
    },
    cellTitle: {
        css: css`
            max-width: ${pxToRem(200)};
            word-wrap: break-word;
            white-space: break-spaces;
        `,
    },
    cellValue: {
        css: css`
            max-width: ${pxToRem(200)};
            word-wrap: break-word;
            white-space: break-spaces;
        `,
    },
    cellAlternateValue: {
        css: css`
            max-width: ${pxToRem(200)};
            color: ${getColor("primary")};
            font-weight: ${x => x.theme.design.typography.weight.semibold};
            word-wrap: break-word;
            white-space: break-spaces;
        `,
    },
    modal: {
        sizeVariant: "large",
    },
    alternativeIcon: {
        icon: {
            size: 20,
            color: "primary",
        },
    },
    disclaimerAction: {
        css: css`
            ${x => x.theme.link.defaultProps?.css}
            margin-top: ${pxToRem(12)};
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
    actionWrapper: {
        css: css`
            display: flex;
            margin-top: ${pxToRem(32)};
        `,
    },
    contactActionLink: {
        css: css`
            ${x => x.theme.button.primary.css}
            padding: ${pxToRem(8, 24)};
            ${buttonThemeStyles("primary")};
            ${buttonStyles("primary")};
        `,
    },
    legalText: {
        size: 8,
    },
};

const styles = productAlternativePackagingTypeInformationStyles;

interface LinkBackProps {
    productLink: PageLinkModel;
}

const LinkBackElement = ({ productLink }: LinkBackProps) => {
    return <LinkBack pageLink={productLink} {...styles.linkBack} />;
};

const ProductAlternativePackagingTypeInformation = ({
    id,
    type,
    productPath,
    productErpNumber,
    superAndSubCategories,
    productAttributeTypes,
    productContext,
    formPageLink,
    fields: {
        disclairmerLabel,
        disclaimerAsLink,
        disclaimerLink,
        openLinkInNewTab,
        disclaimerText,
        contactActionLabel,
        typeDescriptions,
    },
    setProductAlternatePackaging,
    loadProductAlternatePackaging,
}: Props) => {
    const { product } = productContext;
    const [selectedType, setSelectedType] = useState<AlternatePackagingAttributesModel>();
    const [modalIsOpen, setModelIsOpen] = useState<boolean>(false);

    const disclaimerLinkUrl = useGetLink(disclaimerLink).url;

    const alternatePackaging = useAppSelector(state =>
        getAlternatePackagingDataView(state, {
            productErpNumber,
            superAndSubCategories,
            attributeTypes: productAttributeTypes,
        }),
    );

    const CenteringWrapper = styled.div<InjectableCss>`
        ${({ css }) => css}
    `;

    useEffect(() => {
        if (!alternatePackaging.value) {
            loadProductAlternatePackaging({
                productErpNumber,
                superAndSubCategories,
                attributeTypes: productAttributeTypes,
            });
        }

        if (alternatePackaging.value) {
            const _selectedType = alternatePackaging.value.find(x => x.type === type);
            if (_selectedType) {
                setSelectedType({ ..._selectedType });
            }
        }
    }, [alternatePackaging]);

    const productLink: PageLinkModel = {
        id: productContext.product.id,
        url: productPath,
        title: productContext.product.productTitle,
    };

    if (alternatePackaging.value && alternatePackaging.isLoading && !selectedType) {
        return <Loader />;
    }

    if (!selectedType) {
        return (
            <>
                <LinkBackElement productLink={productLink} />
                <CenteringWrapper {...styles.centeringWrapper}>
                    <Typography>{siteMessage("ProductAlternatePackagingPage_NoAlternativeFound")}</Typography>
                </CenteringWrapper>
            </>
        );
    }

    const filteredCurrentAttributes = product.attributeTypes?.filter(attribute => {
        if (!selectedType) {
            return [];
        }

        return selectedType?.alternatePackagingAttributeValueModels!.find(
            x =>
                x.attributeTypeId === attribute.id &&
                x.baseAttributeValueDisplay === attribute.attributeValues![0].valueDisplay,
        );
    });

    const sortedCombinedAttributes = filteredCurrentAttributes
        ?.map(attribute => {
            return {
                attributeId: attribute.id,
                attributeName: attribute.label,
                attributeValue: attribute.attributeValues![0].valueDisplay,
                alternateAttribute: selectedType?.alternatePackagingAttributeValueModels!.find(
                    x => x.baseAttributeValueDisplay === attribute.attributeValues![0].valueDisplay,
                )?.alternateAttributeValueDisplay,
                sortOrder: attribute.sortOrder,
            };
        })
        .sort((a, b) =>
            a.sortOrder === b.sortOrder ? a.attributeId.localeCompare(b.attributeId) : a.sortOrder - b.sortOrder,
        );

    const getAlternativeShortDescription = () => {
        const highLevelType = product?.attributeTypes
            ?.find(x => x.name === "PackagingType")
            ?.attributeValues?.map(x => x.valueDisplay);
        const capacity = product?.attributeTypes
            ?.find(x => x.name === "Capacity")
            ?.attributeValues?.map(x => x.valueDisplay);

        return `${highLevelType} ${capacity} / ${sortedCombinedAttributes
            ?.map(attribute => attribute.alternateAttribute)
            .join(" / ")}`;
    };

    const modalOpenHandler = () => {
        setModelIsOpen(true);
    };

    const modalCloseHandler = () => {
        setModelIsOpen(false);
    };

    const alternativeTypeDescription = typeDescriptions
        .map(x => x.fields)
        .find(x => x["typeKey"] === selectedType.type)?.description;

    return (
        <StyledWrapper {...styles.wrapper}>
            <LinkBackElement productLink={productLink} />
            <StyledWrapper {...styles.typeWrapper}>
                {selectedType.type && (
                    <Typography {...styles.choiceTitle}>
                        {`${
                            // eslint-disable-next-line spire/avoid-dynamic-translate
                            translate(selectedType.type)
                        }
                         ${translate("Choice")}`}
                    </Typography>
                )}
                {alternativeTypeDescription && (
                    <Typography>{parse(alternativeTypeDescription, parserOptions)}</Typography>
                )}
            </StyledWrapper>
            <StyledWrapper {...styles.tableWrapper}>
                <DataTable>
                    <DataTableBody>
                        <DataTableRow>
                            <DataTableCell {...styles.tableHeader}>&nbsp;</DataTableCell>
                            <DataTableCell {...styles.tableHeader}>{translate("For your consideration")}</DataTableCell>
                            <DataTableCell {...styles.tableHeader}>
                                {translate("Packaging You Use Currently")}
                            </DataTableCell>
                        </DataTableRow>
                        <DataTableRow>
                            <DataTableCell {...styles.cellTitle}>{translate("Packaging")}</DataTableCell>
                            <DataTableCell {...styles.cellAlternateValue}>
                                {getAlternativeShortDescription()}
                            </DataTableCell>
                            <DataTableCell {...styles.cellValue}>{product.productTitle}</DataTableCell>
                        </DataTableRow>
                        {sortedCombinedAttributes?.map(attribute => (
                            <DataTableRow key={attribute.attributeId}>
                                <DataTableCell {...styles.cellTitle}>{attribute.attributeName}</DataTableCell>
                                <DataTableCell {...styles.cellAlternateValue}>
                                    {attribute.alternateAttribute}
                                </DataTableCell>
                                <DataTableCell {...styles.cellValue}>{attribute.attributeValue}</DataTableCell>
                            </DataTableRow>
                        ))}
                    </DataTableBody>
                </DataTable>
                {disclaimerAsLink ? (
                    <Link
                        href={disclaimerLinkUrl}
                        target={openLinkInNewTab ? "_blank" : ""}
                        {...styles.disclaimerAction}
                    >
                        {disclairmerLabel}
                    </Link>
                ) : (
                    <Typography {...styles.legalText}>{parse(disclaimerText, parserOptions)}</Typography>
                )}
            </StyledWrapper>
            {contactActionLabel && (
                <StyledWrapper {...styles.actionWrapper}>
                    <Link
                        {...styles.contactActionLink}
                        href={`${formPageLink?.url}?returnUrl=${productPath}&productNumber=${
                            product.productNumber
                        }&recommendedProduct=${getAlternativeShortDescription()}`}
                        onClick={() =>
                            setProductAlternatePackaging({
                                alternativeSummary: getAlternativeShortDescription(),
                                alternativeType: selectedType.type!,
                                currentProductNumber: product.productNumber,
                            })
                        }
                    >
                        {contactActionLabel}
                    </Link>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(
        connect(mapStateToProps, mapDispatchToProps)(ProductAlternativePackagingTypeInformation),
    ),
    definition: {
        group: constants.widgetGroup.alternatePackagingPage,
        displayName: "Alternate Packaging Comparison",
        allowedContexts: [constants.pageType.alternatePackagingPage],
        fieldDefinitions: [
            {
                name: fields.disclairmerLabel,
                displayName: "Show Disclaimer as a Link",
                fieldType: "Translatable",
                editorTemplate: "TextField",
                defaultValue: "* Legal Disclaimer",
            },
            {
                name: fields.disclaimerAsLink,
                displayName: "Show Disclaimer as a Link",
                fieldType: "General",
                editorTemplate: "CheckboxField",
                variant: "toggle",
                defaultValue: true,
            },
            {
                name: fields.disclaimerLink,
                displayName: "Legal Disclaimer Page",
                isVisible: x => x.fields.disclaimerAsLink,
                fieldType: "General",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
            },
            {
                name: fields.openLinkInNewTab,
                displayName: "Open Link In New Tab",
                fieldType: "General",
                isVisible: x => x.fields.disclaimerAsLink,
                editorTemplate: "CheckboxField",
                variant: "toggle",
                defaultValue: true,
            },
            {
                name: fields.disclaimerText,
                fieldType: "Translatable",
                displayName: "Legal Disclaimer Text",
                editorTemplate: "RichTextField",
                defaultValue:
                    "The selection of appropriate packaging remains the responsibility of the customer. If you are interested in discussing various packaging options (related to cost, sustainability, etc.), please contact your Greif account manager. Potential cost benefits from switching packaging depend on numerous factors (including, amongst others, raw material price fluctuations) and indicated benefits cannot be relied on as guaranteed savings. Potential environmental benefits are solely illustrative based on potential scenarios and, therefore, do not assert absolute truth nor necessarily align precisely with your specific circumstances.",
            },
            {
                name: fields.contactActionLabel,
                displayName: "Request Contact Button Label",
                fieldType: "Translatable",
                editorTemplate: "TextField",
                defaultValue: "Consult With Your Sales Manager",
            },
            {
                name: fields.typeDescriptions,
                displayName: "Type Descriptions",
                fieldType: "Translatable",
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.typeKey;
                },
                fieldDefinitions: [
                    {
                        name: fields.typeKey,
                        displayName: "Alternative Type (Key)",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: fields.description,
                        displayName: "Alternative Description",
                        editorTemplate: "RichTextField",
                        defaultValue: "",
                    },
                ],
                defaultValue: [],
            },
        ],
    },
};

export default widgetModule;
